/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import destinationsExample from "data/destinations";
import Country from "models/Country";
import SearchCriteria from "models/TransferModels/SearchCriteria";
import classes from "../style";
import { getCountryISO2 } from "utils/flagUtils";
import ReactCountryFlag from "react-country-flag";
import countryService from "services/countryService";
import RechercheVoyage from "components/home/recherche-voyage";
import AdSlot from "components/AdSlot";

const Destinations: FC<{}> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [destinations, setDestinations] = useState<Country[]>([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const searchCriteria = location.state?.searchCriteria as SearchCriteria;
  if (!searchCriteria) navigate('/');

  useEffect(() => {
    const getDestinations = async () => {
      setIsLoading(true);
      const d = await countryService.searchWithCriteria(searchCriteria, page);
      setHasMore(d.length >= 6);
      setDestinations([...destinations, ...d]);
      setIsLoading(false);
    }

    getDestinations();
  }, [page]);

  useEffect(() => {
    const getDestinations = async () => {
      setIsLoading(true);
      const d = await countryService.searchWithCriteria(searchCriteria, 0);
      setHasMore(d.length >= 6);
      setDestinations(d);
      setIsLoading(false);
    }

    setPage(0);
    getDestinations();
  }, [searchCriteria]);

  return (
    <Container
      sx={{
        ...classes.root,
        ...classes.calendrier,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          my: 2,
        }}
      >
        <Box>
          <RechercheVoyage searchCriteria={searchCriteria} />
        </Box>
      </Box>

      <AdSlot zone='PAYS_SEARCH_TOP' />

      <Box sx={classes.destinationsBloc}>
        <Grid container spacing={3}>
          {
            !isLoading && destinations.length == 0 ?
              <Box display="flex" justifyContent="center" flexGrow={1} mt={5}>
                <Typography textAlign='center' fontWeight={500} fontSize={20}>Désolé, aucun pays ne correspond à votre recherche.</Typography>
              </Box>
              :
              destinations.map((destination) => (
                <Grid item xs={12} md={6} lg={4}>
                  <Card sx={{ minWidth: '250px' }}>
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <Typography gutterBottom variant="h5" component="div">
                            {destination.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#000",
                            }}
                          >
                            {destination.brief ? destination.brief.description : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <ReactCountryFlag countryCode={getCountryISO2(destination.isoCode)} style={{ width: '120px', height: '120px' }} svg />
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                      <Button variant="contained" size="small" onClick={() => {
                        navigate(`/fiche-pays/${destination.id}`, { state: { ...location.state } })
                      }}>
                        Allons-y !
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
        </Grid>

        {hasMore &&
          <Box display="flex" justifyContent="center">
            <Button variant="text" size="small" sx={classes.linkBtn} onClick={() => setPage(page + 1)}>
              Plus de destinations
            </Button>
          </Box>
        }
      </Box>

      <AdSlot zone='PAYS_SEARCH_BOT' />
    </Container>
  );
};

export default Destinations;
